import React from 'react';
import classNames from 'classnames';

import './style.css';

const FormSectionLabel = ({ className, label }) => {
    const classes = classNames('form-section-label', className);

    return (
        <div className={classes}>
            <h5>{label}</h5>
        </div>
    );
};

export default FormSectionLabel;
